module.exports = __webpack_public_path__ + "img/video2.dc3d0551.jpg";